import React, { useEffect } from 'react';
import NewReleasePCConsoleTable from './NewReleasePCConsoleTable';
import NewReleaseMobileTable from './NewReleaseMobileTable';
import { TopchartTableProps } from '@/pages/intelligence/pages/_config/topchartsInterface';

interface NewReleaseTableProps extends TopchartTableProps {
  entityType: string;
}

export default function NewReleaseTable(props: NewReleaseTableProps) {
  const { entityType } = props;
  if (entityType === 'mobile') {
    return <NewReleaseMobileTable {...props} />;
  }
  return <NewReleasePCConsoleTable {...props} />;
}
